import NProgress from 'nprogress';
import router from './router';

import { userStore } from './store/system/user';
import { sfyxj } from './api/policeSituation/common';
import { RouteRecordRaw } from 'vue-router';
// import { auditInsert } from './api/policeSituation/operationLogQuery';
// import '@/components/NProgress/nprogress.less';
// import { notification } from 'ant-design-vue';
// import { resetMenuRouter, updateMenuRouter } from './utils/router';

// NProgress.configure({ showSpinner: false });

const allowList = ['/403', '/login', '/register', '/registerResult'];
export const loginRoutePath = '/auth/login';
// const defaultRoutePath = '/portrait/peopleSearch';
// router.beforeEach(async (to, from, next) => {
//   NProgress.start();
//   const routerNext = () => {
//     // 请求带有 redirect 重定向时，登录自动重定向到该地址
//     // 检查是否有 redirect 参数
//     const redirect = to.query.redirect;

//     if (redirect) {
//       // 如果存在 redirect 参数，则进行重定向
//       next(redirect as string);
//     } else {
//       // 否则继续导航
//       next();
//     }
//   };

//   if (!allowList.includes(to.fullPath)) {
//     try {
//       auditInsert({
//         module: to.meta.title as string,
//         rzlx: '02',
//         czlx: '访问',
//       });
//       await sfyxj();
//       routerNext();
//     } catch (error) {
//       next('/403');
//     }
//   } else {
//     next();
//   }
// });

router.afterEach((c) => {
  NProgress.done();
});
